import React from "react";

const IconCircleWrapper = ({ children, divProps, className }) => {
  return (
    <div
      {...divProps}
      className={`relative h-[38px] w-[38px] active:scale-[0.95] cursor-pointer hover:bg-base-deep-gray hover:dark:bg-base-hover-deep-dark bg-base-white dark:bg-base-deep-dark dark:text-base-white text-base-dark rounded-full items-center justify-center flex ${className}`}
    >
      {children}
    </div>
  );
};

export default IconCircleWrapper;
